import { Card, CardContent } from './ui/card';
import {
  BadgePercent,
  Receipt,
  ShoppingCart,
  TicketPercent,
  Users,
} from 'lucide-react';
import { formatCurrency, formatNumber } from './promotion-report-format';

export default function PromotionKpiCards({ summary }) {
  const cards = [
    {
      id: 'totalDiscount',
      label: 'Total Discount',
      value: formatCurrency(summary?.totalDiscount ?? 0),
      icon: TicketPercent,
    },
    {
      id: 'totalUsages',
      label: 'Promotions Applied',
      value: formatNumber(summary?.totalUsages ?? 0),
      icon: BadgePercent,
    },
    {
      id: 'uniqueOrderCount',
      label: 'Orders Discounted',
      value: formatNumber(summary?.uniqueOrderCount ?? 0),
      icon: ShoppingCart,
    },
    {
      id: 'uniqueCustomerCount',
      label: 'Customers Reached',
      value: formatNumber(summary?.uniqueCustomerCount ?? 0),
      icon: Users,
    },
    {
      id: 'avgDiscountPerOrder',
      label: 'Avg Discount / Order',
      value: formatCurrency(summary?.avgDiscountPerOrder ?? 0),
      icon: Receipt,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map(({ id, label, value, icon: Icon }) => (
        <Card key={id}>
          <CardContent className="pt-6">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="text-xs uppercase text-muted-foreground">
                  {label}
                </div>
                <div className="text-2xl font-semibold mt-1 truncate">
                  {value}
                </div>
              </div>
              <Icon className="h-5 w-5 text-primary shrink-0" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
